import { createMatchingLookupField } from './MatchingLookupField';

export const OrderNumberField = createMatchingLookupField({
    lookupType: 'OrderMatchingLookupType',
    primaryKey: 'orderNumber',
});

export const OrderNumberFieldConditionalComponents = [
    {
        condition: ({ fieldName }) => fieldName === 'order_number',
        component: OrderNumberField,
    },
];
